import React from 'react'
import {FormLabel, FormControlLabel, RadioGroup, Radio, Grid, FormControl} from '@material-ui/core'
import LikeNotLike from './LikeNotLike'

export default function YesNoTypeField({
  type,
  idx,
  onChange = (e, key, value, typeId) => {},
  data,
}) {
  return (
    <Grid container direction="row">
      <FormControl variant="outlined" style={{minWidth: '200px'}}>
        <LikeNotLike type={type} onChange={onChange} idx={idx} data={data} />
      </FormControl>
      <RadioGroup
        aria-label="default"
        name="default"
        value={data?.fix_value}
        onChange={(e, value) => {
          onChange(e, 'list_filters_attributes', value, 'fix_value', idx, '', type.id)
        }}
        row
      >
        <FormControlLabel value="yes" control={<Radio />} label="Yes" />
        <FormControlLabel value="no" control={<Radio />} label="No" />
      </RadioGroup>
    </Grid>
  )
}
